module.exports = __webpack_public_path__ + "img/37.df292826.gif";